import { render, staticRenderFns } from "./VirtualService.vue?vue&type=template&id=02c3870a&"
import script from "./VirtualService.vue?vue&type=script&lang=js&"
export * from "./VirtualService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports